const I = "820px", _ = "428px";
export {
  I as IPAD_AIR_WIDTH,
  _ as IPHONE_PRO_15_WIDTH
};
